import { countryConstants } from "../../constants";

export function countries(state = {}, action) {
  switch (action.type) {
    // get all
    case countryConstants.GET_ALL_REQUEST:
      return {
        loading: true,
      };
    case countryConstants.GET_ALL_SUCCESS:
      return {
        items: action.items,
      };
    case countryConstants.GET_ALL_FAILURE:
      return {
        error: action.error,
      };

    // add
    case countryConstants.ADD_REQUEST:
      return {
        loading: true,
      };
    case countryConstants.ADD_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case countryConstants.ADD_FAILURE:
      return {
        error: action.error,
      };

    // update
    case countryConstants.UPDATE_REQUEST:
      return {
        loading: true,
      };
    case countryConstants.UPDATE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case countryConstants.UPDATE_FAILURE:
      return {
        error: action.error,
      };

    // delete
    case countryConstants.DELETE_REQUEST:
      return {
        loading: true,
      };
    case countryConstants.DELETE_SUCCESS:
      return {
        parameter: action.parameter,
      };
    case countryConstants.DELETE_FAILURE:
      return {
        error: action.error,
      };

    // clear
    case countryConstants.CLEAR:
      return {};

    default:
      return state;
  }
}
